import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const harborTransactionListState = atom({
    key: 'harborTransactionListState',
    default: [],
})


export const modalConfigDefault = { size: "md", wizard: false }

export const harborTransactionFilterState = selector({
    key: 'harborTransactionFilterState',
    get: () => ([])
})


export const formModes = {
    view: [ { name: 'Default View' } ],
}

export const harborTransactionDataStructureState = selector({
    key: 'harborTransactionDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Reference',
                field: 'transaction_number',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            {
                label: 'Vessel',
                field: 'vessel_label',
                type: 'text',
                order: { table: 1.5, form: 1.5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            { 
                label: 'Type',
                field: 'transaction_type',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            // { 
            //     label: 'Subtotal',
            //     type: 'number',
            //     order: { table: 4, form: 4 }, 
            //     create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            // },
            // { 
            //     label: 'Tax Amount',
            //     type: 'number',
            //     order: { form: 5 }, 
            //     create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            // },
            {
                label: 'Net Amount',
                type: 'number',
                order: { table: 6, form: 6 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
